import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const unlockUserLogin = async (userId) => {
  try {
    const response = await apiClient.put(`/users/unlockLogin/${userId}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
